import { createBasketItem } from './basket-item';
import { getRandomInt } from '../utilities/get-random-int';

export const createBasketList = (amount = 1) => {
  const list = [];
  for (let i = 0; i < amount; i++) {
    list.push(
      createBasketItem({
        quantity: getRandomInt(15),
        itemPrice: getRandomInt(999),
      }),
    );
  }
  return list;
};
